import * as React from "react";

import type { DesignaliProps } from "../../types";

export const ArtificialIntelligence07 = React.forwardRef<
  SVGSVGElement,
  DesignaliProps
>(({ ...props }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={forwardedRef}
    >
      <path
        fill="none"
        d="M12.96,2c-.72,0-1.59,0-1.86.19s-.38.52-.61,1.18c-.26.75-.44,1.52-1.16,1.97l-.35.19c-.88.44-1.78.07-2.66-.17-.46-.13-.9-.16-1.17-.17-.17,0-.32.08-.41.23l-1.64,2.73c-.09.14-.1.32-.01.47.13.22.34.55.63.87.69.75,1.51,1.42,1.51,2.53s-.81,1.78-1.51,2.53c-.29.31-.51.65-.63.87-.08.15-.07.32.01.47l1.64,2.73c.09.14.24.24.41.23.27-.01.71-.05,1.17-.17.88-.24,1.78-.61,2.66-.17l.35.19c.72.45.9,1.22,1.16,1.97.23.66.34.99.61,1.18.27.19,1.14.18,1.86.18"
      />
      <path
        fill="none"
        d="M12.96,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5"
      />
      <path
        fill="none"
        d="M20.21,4.75l-2.25,2.25h-2M19.46,4.75c0,.41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75Z"
      />
      <path
        fill="none"
        d="M20.21,19.25l-2.25-2.25h-2M19.46,19.25c0-.41.34-.75.75-.75s.75.34.75.75-.34.75-.75.75-.75-.34-.75-.75Z"
      />
      <path
        fill="none"
        d="M20.21,12h-4.25M19.46,12c0,.41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75Z"
      />
    </svg>
  );
});

export default ArtificialIntelligence07;
